import { render, staticRenderFns } from "./imagepicker.vue?vue&type=template&id=153fe052&"
import script from "./imagepicker.vue?vue&type=script&lang=ts&"
export * from "./imagepicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('153fe052')) {
      api.createRecord('153fe052', component.options)
    } else {
      api.reload('153fe052', component.options)
    }
    module.hot.accept("./imagepicker.vue?vue&type=template&id=153fe052&", function () {
      api.rerender('153fe052', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/imagepicker.vue"
export default component.exports